const initMotionCommon = (duration) => ({
    animationDuration: duration,
    animationFillMode: 'both',
});
// FIXME: origin less code seems same as initMotionCommon. Maybe we can safe remove
const initMotionCommonLeave = (duration) => ({
    animationDuration: duration,
    animationFillMode: 'both',
});
export const initMotion = (motionCls, inKeyframes, outKeyframes, duration) => ({
    [`
    ${motionCls}-enter,
    ${motionCls}-appear
  `]: Object.assign(Object.assign({}, initMotionCommon(duration)), { animationPlayState: 'paused' }),
    [`${motionCls}-leave`]: Object.assign(Object.assign({}, initMotionCommonLeave(duration)), { animationPlayState: 'paused' }),
    [`
    ${motionCls}-enter${motionCls}-enter-active,
    ${motionCls}-appear${motionCls}-appear-active
  `]: {
        animationName: inKeyframes,
        animationPlayState: 'running',
    },
    [`${motionCls}-leave${motionCls}-leave-active`]: {
        animationName: outKeyframes,
        animationPlayState: 'running',
        pointerEvents: 'none',
    },
});
